<template>
  <div class="News">
    <div class="list"
         ref='homeUl'>
      <van-pull-refresh class="refresh"
                        v-model="isLoading"
                        @refresh="onRefresh">
        <router-link :to="'/news-detail/'+item.id"
                     class="lis"
                     v-for="(item,index) in newsList"
                     :key="index">
          <van-row>
            <van-col span="24">
              <h3> {{item.title}} </h3>
            </van-col>
            <van-col span="16">
              <div class="desc">
                {{item.description}}
              </div>
              <div class="data">
                {{item.updated_at}}
              </div>
            </van-col>
            <van-col span="8">
              <div class="imgbox">
                <img :src="item.thumb"
                     alt="">
              </div>
            </van-col>
          </van-row>
        </router-link>

        <van-loading v-if="loadingShow"
                     style="text-align:center"
                     :style="{ color: '#f29810'}"
                     size="24px">加载中...</van-loading>
        <div class="nomore"
             v-if="notList">
          没有更多了
        </div>
      </van-pull-refresh>

    </div>

  </div>
</template>

<script>
import axiosApi from "../api/api.js";

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      newsList: [],
      pagNum: 1,
      custid: 19,
      totalnum: 12,
      listLength: [],
      notList: false,
      loadingShow: false,
      isLoading: false,
    }
  },
  created () {
    // this.custid = this.$route.params.id
    // this.$store.commit('update_newsClass', this.$route.params.id)

    //初始化加载数据
    this.methodsGetMessage(this.custid, this.pagNum)
  },
  // beforeMount () {
  //   console.log(this.$route.params.id)
  //   axiosApi(
  //     'news/' + this.$route.params.id, {}, 'get'
  //   ).then((res) => {
  //     this.newsList = res.data.data
  //   })
  // },
  mounted () {
    //监听如果页面发生滚动时
    this.$nextTick(() => {
      // console.log(document.documentElement.scrollTop)
      // window.addEventListener('scroll', this.handleScroll, true);
      this.$refs.homeUl.addEventListener('scroll', this.handleScroll, true);
    })
  },
  methods: {
    //初始化加载数据
    methodsGetMessage (custid, pageNum) {
      this.loadingShow = true
      axiosApi(
        'news/' + custid + '?page=' + pageNum, {}, 'get'
      ).then((res) => {
        setTimeout(() => {
          this.loadingShow = false
          if (res.code == 200) {
            this.pagNum += 1;
            if (res.data.data == []) {
              this.newsList = []
            } else {
              if (res.data.total <= 12) {
                this.notList = true
              }
              this.totalnum = Math.ceil(res.data.total / 12)
              var list = res.data.data
              this.newsList = list
              this.listLength = list.length
            }
            //隐藏
          } else {
            console.log('获取消息失败')
          }
        }, 500)
      })
    },
    //页面滑到底部需要调用的方法
    handleScroll () { //下面这部分兼容手机端和PC端
      var scrollTop = this.$refs.homeUl.scrollTop; //滚动条的位置
      var windowHeitht = this.$refs.homeUl.clientHeight; //在页面上返回内容的可视高度
      var scrollHeight = this.$refs.homeUl.scrollHeight; //返回整个元素的高度（包括带滚动条的隐蔽的地方）
      //是否滚动到底部的判断
      let flg = true
      if ((Math.round(scrollTop) + windowHeitht + 2) >= scrollHeight) {
        if (flg) {
          flg = false
          setTimeout(() => {
            flg = true
          }, 500)
          if (this.pagNum <= this.totalnum) {
            this.methodsGetMessage(this.custid, this.pageNum, this.pageSize)
          } else {
            this.notList = true
            return;
          }
        }

      }
    },
    onRefresh () {
      axiosApi(
        'news/' + this.custid, {}, 'get'
      ).then((res) => {
        setTimeout(() => {
          this.pagNum = 1
          this.notList = false
          this.isLoading = false;
          this.newsList = res.data.data
          if (res.data.total <= 12) {
            this.notList = true
          }
        }, 200)

      })
    }
  },

}
</script>

<style lang="scss" scoped>
.refresh {
  height: 100%;
}
.list {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.refresh {
  padding: 20px;
}
.lis {
  display: block;
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 40px;
  h3 {
    margin-bottom: 15px;
  }
  .imgbox {
    border-radius: 10px;
  }
  .desc {
    height: 90px;
    overflow: hidden;
    padding-right: 20px;
    font-size: 24px;
    line-height: 30px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .data {
    margin-top: 10px;
  }
}
.van-loading__text {
  color: #f29810;
}
</style>
